import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["direction", "children"];
import styled from 'foundations-theming/utils';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { MERCURY_LAYER } from '../../constants';
import { MIN_HEIGHT, MIN_WIDTH } from '../../../constants/nonTokenisedValues';
import { jsx as _jsx } from "react/jsx-runtime";
const horizontalFletching = {
  width: '50%',
  height: '100%',
  top: '0' // required for IE11 (#6871)
};
const verticalFletching = {
  width: '110%',
  height: '50%',
  left: '-5%'
};
const positionStyles = {
  top: Object.assign({}, verticalFletching, {
    bottom: '0',
    transform: 'skew(-30deg)'
  }),
  bottom: Object.assign({}, verticalFletching, {
    top: '0',
    transform: 'skew(30deg)'
  }),
  left: Object.assign({}, horizontalFletching, {
    left: '0',
    transform: 'skew(0deg, 24deg)'
  }),
  right: Object.assign({}, horizontalFletching, {
    right: '0',
    transform: 'skew(0deg, -24deg)'
  })
};
const makeFletching = position => Object.assign({
  position: 'absolute',
  backgroundColor: 'currentColor',
  content: '""'
}, positionStyles[position]);
const OuterWrapper = styled.span.withConfig({
  displayName: "Chevron__OuterWrapper",
  componentId: "sc-1239qny-0"
})(({
  $direction,
  $cssStyles,
  theme
}) => {
  return Object.assign({
    alignItems: 'center',
    display: 'inline-flex'
  }, theme.typography['detail-200'], {
    color: theme.color['fill-primary-disabled'],
    minHeight: $direction === 'down' ? MIN_HEIGHT.CHEVRON_OUTER_WRAPPER_DOWN : MIN_HEIGHT.CHEVRON_OUTER_WRAPPER_RIGHT,
    minWidth: $direction === 'down' ? MIN_WIDTH.CHEVRON_OUTER_WRAPPER_DOWN : undefined,
    padding: theme.space['100'],
    paddingLeft: $direction !== 'down' ? theme.space['300'] : undefined,
    position: 'relative',
    textAlign: 'center',
    justifyContent: 'center',
    '&::before': makeFletching($direction === 'down' ? 'left' : 'top'),
    '&::after': makeFletching($direction === 'down' ? 'right' : 'bottom')
  }, $cssStyles);
});
const InnerWrapper = styled.span.withConfig({
  displayName: "Chevron__InnerWrapper",
  componentId: "sc-1239qny-1"
})(({
  theme
}) => {
  return {
    color: theme.color['text-core-default'],
    minWidth: '30px',
    position: 'relative',
    zIndex: MERCURY_LAYER
  };
});
export const Chevron = _ref => {
  let {
      direction = 'right',
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    tokenProps,
    domProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(OuterWrapper, Object.assign({
    $direction: direction,
    $cssStyles: cssStyles
  }, domProps, {
    children: /*#__PURE__*/_jsx(InnerWrapper, {
      children: children
    })
  }));
};